import React from "react";
import styled from "styled-components";
import { useAuth } from "../context/AuthContext";

const getPartOfDay = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  return "evening";
};

const getQuotes = (partOfDay, name) => {
  const quotes = {
    morning: [
      `Good morning, ${name}! Ready to smash it today?`,
      `Rise and shine, ${name}! Let's conquer the day.`,
      `Morning, ${name}! It's a great day to make things happen.`,
    ],
    afternoon: [
      `Keep it up, ${name}! You're doing amazing this afternoon!`,
      `Stay focused, ${name}. The afternoon is yours to win.`,
      `Hi ${name}, you're halfway there. Keep pushing forward!`,
    ],
    evening: [
      `One more hour, ${name}. You can do it!`,
      `Good Evening, ${name}! You crushed it today.`,
      `Evening vibes, ${name}. Late night working always feels like a great grind!`,
    ],
  };
  return quotes[partOfDay][Math.floor(Math.random() * 3)];
};

const Quote = () => {
  const { currentUser } = useAuth();
  const partOfDay = getPartOfDay();
  const quote = currentUser
    ? getQuotes(partOfDay, currentUser.displayName || "User")
    : "Welcome back!";

  return <QuoteContainer>{quote}</QuoteContainer>;
};
const QuoteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 1.5rem;
  padding: 20px;
`;

export default Quote;
